import styled from 'styled-components';
import color from '../utils/style/color';

const Button = styled.button`
  width: 100%;
  max-width: 320px;
  height: 48px;
  border-radius: 2px;
  box-shadow: 0 0 2px 0 rgba(221, 221, 221, 0.5);
  background-color: ${color.red.brand};
  &:hover {
    cursor: pointer;
  }
  &:disabled {
    background-color: ${color.gray.bright};
    cursor: not-allowed;
  }
`;

export default Button;
